var React = require('react');

function LandInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2","d":"M1 16H34V49H1zM39 22L44 17 49 22M49 43L44 48 39 43M44 47.294L44 17.333M28 11L33 6 28 1M7 1L2 6 7 11M2.706 6L32.668 6"}));
}

LandInline.defaultProps = {"fill":"currentColor","viewBox":"0 0 50 50","width":"50px","height":"50px"};

module.exports = LandInline;

LandInline.default = LandInline;
